// extracted by mini-css-extract-plugin
export default {"sideNav":"side-nav_sideNav__owE1d"};